import { Button, Col, Colors, Text } from 'basic-ui-lib';
import { FooterMobile } from 'layouts/widgets/BottomMobile';
import HeaderMobile from 'layouts/widgets/HeaderMobile';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import UploadFile, { UploadFileProps } from '../Dashboard/LibraryList/UploadImageOrVideoModal/UploadFile';
import { Form } from 'antd';
import BaseInput from 'basic-ui-lib/components/Input/BaseInput';
import { setPageLoading } from 'widgets/PageLoading';
import mediaApis from 'modules/media/services/apis';
import toast from 'utils/toast';
import { getMessageError } from 'services/response';

interface FormValues {
  file: UploadFileProps['value'];
  name: string;
}

const UploadImageOrVideo = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const location = useLocation();
  const { currentPath } = location.state || { currentPath: ' ' };

  const handleFinish = async (values: FormValues) => {
    const formData = new FormData();
    if (values.file?.file) {
      formData.append('file', values.file.file);
    }
    formData.append('path', currentPath);

    try {
      setPageLoading(true);

      const res = await mediaApis.uploadMediaItem(formData);

      if (res?.data?.data) {
        toast.success('Upload successful');
        navigate('/media');
      }
    } catch (error) {
      toast.error(getMessageError(error) || 'Upload failed');
    } finally {
      setPageLoading(false);
    }
  };

  return (
    <Container>
      <HeaderMobile title='Upload Image/Video' />
      <Content>
        <Form layout='vertical' form={form} onFinish={handleFinish}>
          <Form.Item name='name' label='Name' rules={[{ required: true, message: 'Please enter name' }]}>
            <BaseInput placeholder='Enter name' />
          </Form.Item>
          <Form.Item name='file' rules={[{ required: true, message: 'Please upload image or video' }]}>
            <UploadFile />
          </Form.Item>
          <Col gap={0}>
            <Text caption_3 regular center color='neutral.text.3'>
              We support PNG, JPEG, JPG, MP4, GIF
            </Text>
            <Text caption_3 regular center color='neutral.text.3'>
              Portrait (1080×1920) or landscape (1920×1080) for best quality
            </Text>
          </Col>
        </Form>
      </Content>
      <FooterMobile>
        <Button
          lg
          type_cancel
          onClick={() => navigate(-1)}
        >
          Cancel
        </Button>
        <Button lg type_second type='submit' onClick={() => form.submit()}>
          OK
        </Button>
      </FooterMobile>
    </Container>
  );
};

export default UploadImageOrVideo;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const Content = styled.div`
  flex: 1;
  padding: 24px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${Colors.neutral.bg[2]};
`;
